import {
  StudentApplication,
  StudentApplicationMutationValues,
  StudentApplicationCreationValues,
  HelperResult,
} from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetParams {
  id: string;
  params?: { context?: 'resume' };
}

const {
  useGet: useStudentApplication,
  useCreate: useStudentApplicationCreation,
  useUpdate: useStudentApplicationUpdate,
  useFind: useStudentApplications,
} = getCRUDHooks({
  entityName: 'studentApplication',
  get: ({ id, params = {} }: GetParams): HelperResult<StudentApplication> =>
    clientApi
      .getOCClient()
      .createGetRequest<StudentApplication>('/student-applications/:id')
      .setRouteParam('id', id)
      .setQueryParams(params)
      .execute(),

  create: (
    values: StudentApplicationCreationValues,
    { userId }: { userId: number }
  ): HelperResult<StudentApplication> =>
    clientApi.getOCClient().helpers.user.users.id(userId).studentApplications.create(values),

  update: (
    { stepName, ...rest }: StudentApplicationMutationValues,
    { studentApplicationId, context }: { studentApplicationId: string; context?: any }
  ): HelperResult<StudentApplication> => {
    const request = clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.partialUpdate(
        studentApplicationId,
        { ...rest },
        false
      );

    const screenContext = stepName
      ? JSON.stringify({
          purpose: 'student-application',
          studentApplicationId,
          studentApplicationStep: stepName,
          studentApplicationQuestion: stepName,
        })
      : undefined;

    request.setHeaders({
      ...(context || screenContext ? { 'X-Request-Context': context || screenContext } : {}),
    });
    return request.execute();
  },

  find: ({ userId }: { userId: number }): HelperResult<StudentApplication[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).studentApplications.find(),
});

export {
  useStudentApplication,
  useStudentApplicationCreation,
  useStudentApplicationUpdate,
  useStudentApplications,
};
